export default "__VITE_ASSET__CmpocjKe__"